var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contenuAdmin"}},[_c('MenuAdmin',{attrs:{"id":"menuTop"}}),(!_vm.$isMobile())?_c('sidebar-menu',{staticClass:"v-sidebar-menu-admin",attrs:{"menu":_vm.verticalMenu,"collapsed":_vm.myCollapse},on:{"collapse":_vm.onCollapse}}):_vm._e(),_c('div',{attrs:{"id":"main"}},[_c(_vm.layout,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }